import { useApiGet } from "@ametie/vue-muza-use";
import type { UseApiOptions } from "@ametie/vue-muza-use";

import type { PageVisit } from "../tracking";
import type { PageVisitReport, PageVisitReportParams } from "../types";

import { myAxios } from "@/shared/config/axios";

// Router hooks run outside component setup, so telemetry uses the shared authenticated client.
export const postPageVisit = async (visit: PageVisit): Promise<void> => {
  await myAxios.post("/page-visits", visit);
};

export default () => {
  const fetchPageVisitReport = (options?: UseApiOptions<PageVisitReport, PageVisitReportParams>) =>
    useApiGet<PageVisitReport>("/page-visits/report", { cache: true, ...options });

  return { fetchPageVisitReport };
};
